import { createFileRoute } from "@tanstack/react-router"
import { CommunicationSurveysPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/surveys"
)({
  component: () => (
    <AuthorizationGate
      resource={Resource.COMMUNICATION_TEMPLATES}
      action={Action.READ}
    >
      <CommunicationSurveysPage />
    </AuthorizationGate>
  ),
})
